import CircularProgress from '$tablet-app/src/app/components/CircularProgress';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  emoji?: string;
  diameter?: number;
  width?: number;
  progress?: number;
}

const MiniCompletionCircle: FC<Props> = (props) => {
  const { diameter = 66, width = 3, progress = 0, emoji = '🎯' } = props;
  const isComplete = progress === 100;

  return (
    <CircleWrapper height={diameter}>
      <CircularProgress
        radius={diameter / 2}
        rotation={0}
        strokeLinecap="butt"
        activeStrokeWidth={width}
        inActiveStrokeWidth={width}
        value={progress || 0}
        activeStrokeColor={
          isComplete ? palette.Emerald_green : palette.Primary_blue
        }
        inActiveStrokeColor="rgba(230, 232, 235, 1)"
      >
        <EmojiContainer style={isComplete ? completedEmojiStyle : undefined}>
          <Emoji>{emoji || '🎯'}</Emoji>
        </EmojiContainer>
      </CircularProgress>
    </CircleWrapper>
  );
};

const completedEmojiStyle = { backgroundColor: palette.Emerald_green };

const CircleWrapper = styled(View)<{ height: number }>`
  height: ${({ height }) => height}px;
  align-items: center;
`;

const EmojiContainer = styled.View`
  width: 53px;
  height: 53px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background-color: rgba(5, 22, 51, 0.1);
`;

const Emoji = styled(Text)`
  font-size: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export default MiniCompletionCircle;
